<template>
  <div class="walletInfo">
    <div class="info">
      <el-row :gutter="20">
        <el-col
          :lg="12"
          :md="12"
          :sm="24"
        >
          <div class="item master ">
            <div class="title">主钱包</div>
            <div class="line">
              <span>USDT</span>
              <span>{{info.primaryUsdt}}</span>
            </div>
            <div class="line">
              <span>TRX</span>
              <span>{{info.primaryTrx}}</span>
            </div>
            <div class="line">
              <span>钱包地址</span>
              <span>{{info.primaryAddress}}</span>
            </div>
            <div class="line qrcode">
              <span>二维码</span>
              <span>
            <img class="qrcode-img" :src="info.primaryQrUrl" alt="">
          </span>
            </div>
          </div>
        </el-col>

        <el-col :span="12">
          <div class="item sub">
            <div class="title">归集钱包</div>
            <div class="line">
              <span>USDT</span>
              <span>{{info.collectionUsdt}}</span>
            </div>
            <div class="line">
              <span>钱包地址</span>
              <span>{{info.collectionAddress}}</span>
            </div>
            <div class="line qrcode">
              <span>二维码</span>
              <span>
            <img class="qrcode-img" :src="info.collectionQrUrl" alt="">
          </span>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="config">
      <h5 class="title">配置</h5>
      <el-form
        ref="form"
        :model="form"
        :rules="rules"
        hide-required-asterisk
        label-position="top"
      >
        <el-form-item
          label="手续费"
          prop="fee"
        >
          <el-input
            style="width: 350px;"
            v-model="form.fee"
            placeholder="请输入"
            :disabled="flag"
          >
            <span
              slot="suffix"
              >每笔
            </span>
          </el-input>
        </el-form-item>
        <el-form-item>
          <template v-if="disabled">
            <vs-button
              @click="editHandle"
              class="mar-right10"
              type="filled"
              color="primary"
            >编辑</vs-button>
          </template>
          <template v-if="!disabled">
            <vs-button @click="submit" class="mar-right10" type="filled" color="primary">确认</vs-button>
            <vs-button @click="cancel" type="border"  color="primary">取消</vs-button>
          </template>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
  import { queryWalletnfo,updatePayFee } from '@/api/wallet'
  export default {
    name: "index",
      components:{
    },
    data() {
      return {
        info: {
          primaryUsdt: '',
          primaryTrx: '',
          address: '',
          qrCode: '',
        },

        form:{
          fee: '',
        },
        rules:{
          fee: [
            {
              required: true, message: '请输入',trigger: 'blur'
            }
          ]
        },
        disabled: true,
      }
    },
    created(){
      this.getInfo();
    },
    computed: {
      flag() {
        return this.disabled
      }
    },
    methods: {
      getInfo(){
        queryWalletnfo().then((res) => {
          console.log(res);
          this.info = res.data;
          this.form.fee = res.data.payFee;
        })
      },
      getState(tr){
        return tr.status == 1 ? '禁用': '开启';
      },
      editHandle(){
        this.cacheFee = this.form.fee;
        this.disabled = false;
      },
      cancel(){
        this.form.fee = this.cacheFee;
        this.disabled = true;
      },
      submit(){
        // ajax
        this.$refs.form.validate((valid) => {
          if(valid){
            updatePayFee({
              payFee: this.form.fee,
            }).then((res) => {
              console.log(res);
              this.disabled = true;
              this.$vs.notify({
                text: '修改成功',
                position: 'top-right'
              });
            })
          }
        })
      }
    },
  }
</script>

<style lang="scss" scoped>
.walletInfo {
  .info {
    background-color: #ffffff;
    padding: 1.4rem;
    border-radius: 6px;
    margin-bottom: 1rem;
    .item {
      .title {
        font-size: 14px;
        font-weight: bold;
        margin-bottom: 1rem;
      }
      .line {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 1.2rem;
        color: #6E6B7B;
        &.qrcode {
          align-items: flex-start;
        }
      }
      &.master {
        border-right: 1px solid #EBE9F1;
        padding-right: 20px;
      }
    }
  }
  .config {
    background-color: #ffffff;
    padding: 1.4rem;
    border-radius: 6px;
    .title {
      color: #5E5873;
      margin-bottom: 20px;
    }
    /deep/ .el-input__suffix {
      right: 15px;
    }
  }
  .qrcode-img {
    width: 80px;
    height: 80px;
  }
}
</style>
